import './lib/types/global'

import { createApp } from 'vue'
import PurchaseProductApp from './apps/PurchaseProductApp.vue'
import productSpotlight from './modules/productSpotlight'
import starterKitLp from './modules/starterKitLp'
import starterKitMultistepLp from './modules/starterKitMultistepLp'

const el = document.querySelector(
  '#purchase-product-root',
) as HTMLElement | null

if (el && el.dataset && el.dataset.productJson) {
  const product = JSON.parse(el.dataset.productJson)
  createApp(PurchaseProductApp, {
    product,
    neverPromptLogin: true,
    immediateCheckout: true,
  }).mount(el)
}

starterKitLp()
starterKitMultistepLp()
productSpotlight()
